/** 
 * 参数介绍：
 *  - upcode=zhennlife 地址上带有upcode参数，将自动跳过输入upcode查询界面，自动进入充值档界面
 *  - lang=zh-CN  多语言包匹配参数，如果不传，默认是简体中文
 *  - channel=xenopay  支付页面提供多种支付渠道，此参数决定默认选择何种支付渠道，如果不传默认为paypal

 *  - result_code 支付结果页面的标识，FAIL 代表取消支付或支付失败  SUCCESS 支付成功，分别对应两种不同的结果页UI展示
 */
import '../css/reset.css';
import '../css/whatever.css';
import 'babel-polyfill';
import React, { Component } from 'react';
import ReactDOM, { render } from 'react-dom';
import Xifsscr from "up-xifsscr";
import FastClick from 'c-fastclick';
import url from 'c-url';
import Result from './result/index';
import Process from './process/index';
import lang from './lang/index';
import BankSuccess from './result/bank-success';

FastClick.attach(document.body);
lang.init();

if (url.query('channel') == 'wechat') {
    let _url = 'http://h5.upliveapp.com/uplive/recharge.html';
    let target = _url + '?' + $.param({
        env: url.query('env') || 'pro',
    });

    location.href = target;
}

import UReport from 'uplive-report'

const env = url.query('env');

if (env !== 'stage') {
    try {
        const appId = 'N3hHhyj1624956279508'
        UReport({
            domain: 'https://apm.upliveapp.com/api/v1/report/web', //你的api地址
            add: {
                appId
            }
        })
    }
    catch (e) {
        console.log(e)
    }

}
const showconsole = url.query("showconsole"); // 是否显示log信息
function getSiteKey() {
  return env != "stage"
    ? "6LehykohAAAAAMpbs7zayi9a1ARwcBGeSOjrxkyK"
    : "6LfyGWwhAAAAANlDGQDAe0rTtJqeOslAksefVacB";
}

Xifsscr({
  siteKey: getSiteKey(),
  action: "init",
  noconsole: !showconsole,
});

if (url.query('channel') == 'mycard') {

    let locationUrl = location.href;
    let newUrl = url.addParam(url.delQuery(locationUrl, 'channel'), { channel: 'twrecharge' });
    location.href = newUrl;
}

if (url.query('channel') == 'paytm' || url.query('channel') == 'codapay_390' || url.query('channel') == 'codapay_391') {
    let locationUrl = location.href;
    let newUrl = url.addParam(url.delQuery(locationUrl, 'channel'), { channel: 'dokypay' });
    location.href = newUrl;
}


if (url.query('channel') == 'icard') {
    let locationUrl = location.href;
    let newUrl = url.addParam(url.delQuery(locationUrl, 'channel'), { channel: 'bk_atm' });
    location.href = newUrl;
}

class App extends Component {
    render() {
        // 标示是否为支付结果页面
        let inResultPage = !!(url.query('result_code'));
        return inResultPage ? <Result /> : <Process />;
    }
}

render(<App />, $('#wrap')[0]);

//render(<BankSuccess />, $('#wrap')[0]);
$.channel.on('bankComplete', (orderData) => {
    console.log('ssssssssss');
    console.log(orderData);
    render(<BankSuccess orderData={orderData} />, $('#wrap')[0]);
});


// WEBPACK FOOTER //
// ./js/app.js